import { distinctArrayBy } from '@elementary/common-ui/utils/common';
import {
  parseApiTestRun,
  type ApiTestRunData,
} from '@elementary/common-ui/pages';
import { TestRun } from '@elementary/common-ui/types';

export const mapTestRunRows = (items: ApiTestRunData[]): TestRun[] =>
  distinctArrayBy(items, 'execution.subTestUniqueId').map(parseApiTestRun);
